import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

export type CalendarDateNames = [string,string,string,string,string,string,string];
export interface CalendarOptions {
  value?:Date,
  min?:Date,
  max?:Date,
  title?:string,
  dayNames?:CalendarDateNames,
  AMPMNames?:[string,string],
  timePicker?: boolean
}
@Component({
  selector: 'app-calendar-popover',
  templateUrl: './calendar-popover.component.html',
  styleUrls: ['./calendar-popover.component.scss'],
})
export class CalendarPopoverComponent implements OnInit {

  @Input('timePicker') timePicker:boolean = false;
  @Input('type') type:'date' | 'week' = 'date';

  @Input('value') value:Date | null = null;
  innerMin:Date = new Date(1900, 0, 1);
  innerMax:Date = new Date(2100, 11, 1);
  @Input('min') set min(v:Date | string) { 
    if(typeof v === 'string') {
      if(v.indexOf('-') > -1) {
        const vs = v.split('-');
        this.innerMin = new Date(Number(vs[0]),Number(vs[1])-1,Number(vs[2]));
      } else this.innerMin = new Date(1900, 0, 1);
    } else this.innerMin = v;
  }
  get min() { return this.innerMin; }
  @Input('max') set max(v:Date | string) { 
    if(typeof v === 'string') {
      if(v.indexOf('-') > -1) {
        const vs = v.split('-');
        this.innerMax = new Date(Number(vs[0]),Number(vs[1])-1,Number(vs[2]));
      } else this.innerMax = new Date(2100, 11, 1);
    } else this.innerMax = v;
  }
  get max() { return this.innerMax; }
  @Input('title') title:string = '';
  @Input('yearName') yearName = '년';
  @Input('monthName') monthName = '월';
  @Input('dayNames') dayNames:CalendarDateNames = ['일','월', '화', '수', '목', '금', '토'];
  @Input('AMPMNames') AMPMNames: [string, string] = ['오전', '오후'];
  @Input('disableDaysOfWeek') disableDaysOfWeek = [];

  //now:Date = new Date();
  yearList = (() => {
    const todayYear = new Date().getFullYear();
    let years = [];
    for(let i = 0; i < 80; i++) {
      years.push(todayYear - 78 + i);
    }
    return years;
  })()
  displayDate:Date = this.value || new Date();
  displayYear = this.displayDate.getFullYear();
  displayMonth = this.displayDate.getDate();
  displayHours = this.fixHours(this.displayDate.getHours());
  displayMinutes = this.displayDate.getMinutes();
  displayAMPM:'AM'|'PM' = this.displayHours <= 12 ? 'AM' : 'PM';
  selectedDate:Date = null;
  dates:Date[] = [];
  dateNames:number[] = [];
  todayYear = new Date().getFullYear();

  constructor(
    private _popover: PopoverController
  ) {}
  ngOnInit(){
    if(!this.value) this.value = new Date();
    else if(isNaN(this.value.getTime())) this.value = new Date();
    this.displayDate = this.value;
    this.selectedDate = this.value;
    this.setDisplay();
  }
  dismiss() {
    this._popover.dismiss();
  }
  containInArray(value, arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == value) {
        return true;
      }
    }

    return false;
  }
  disableDate(index) {
    if (this.dates[index] < this.min || this.dates[index] > this.max) {
      return true;
    }

    var dayOfWeek = this.dayNames[index % 7];
    return this.containInArray(dayOfWeek, this.disableDaysOfWeek);
  }

  notDisplayMonthDate(index) {
    const datesMonth = this.dates[index].getMonth();
    return datesMonth !== this.displayMonth;
  }
  selectDate(index) {
    if(!this.disableDate(index)) {
      this.selectedDate = this.dates[index];
      const selectedMonth = this.selectedDate.getMonth();
      if(selectedMonth !== this.displayMonth) {
        this.displayDate.setMonth(selectedMonth);
        this.setDisplay();
      }
    }
  }
  seletedDateFill(index) {
    if(this.selectedDate) {
      switch(this.type) {
        case 'date':
          return this.selectedDate.getTime() === this.dates[index].getTime();
        case 'week':
          const day = this.selectedDate.getDay();
          return this.dates[index].getTime() >= this.selectedDate.getTime() - (86400000*day)
          && this.dates[index].getTime() <= this.selectedDate.getTime() + (86400000*(6-day));
      }
    } else {
      return false;
    }
  }
  prevMonth() {
    const lastMonth = this.displayDate.getMonth() - 1;
    this.displayDate.setMonth(lastMonth);
    this.setDisplay();
  }
  nextMonth() {
    const nextMonth = this.displayDate.getMonth() + 1;
    this.displayDate.setMonth(nextMonth);
    this.setDisplay();
  }
  setYear(value) {
    if(value !== null) {
      this.displayDate.setFullYear(value);
      this.setDisplay();
    }
  }
  setMonth(value) {
    if(value !== null) {
      this.displayDate.setMonth(value);
      this.setDisplay();
    }
  }
  setHours(hours) {
    this.displayHours = this.fixHours(hours);
  }
  setMinute(minutes) {
    this.displayMinutes = this.fixMinutes(minutes);
  }
  setAMPM() {
    this.displayAMPM === 'AM' ? this.displayAMPM = 'PM' : this.displayAMPM = 'AM';
  }
  setDisplay() {
    this.displayYear = this.displayDate.getFullYear();
    this.displayMonth = this.displayDate.getMonth();
    const dateLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; 
    if((this.displayYear%4 === 0 && this.displayYear%100 !== 0) || this.displayYear%400 === 0) {
      dateLength[1] = 29;
    }
    
    const calendarDateLength = 42;
    const firstDay = new Date(this.displayYear, this.displayMonth, 1).getDay();
    const roofDate = new Date(this.displayYear, this.displayMonth, 1 - firstDay);

    const dates = [];
    let dateNames = [];
    for(let i = 0; i < calendarDateLength; i++) {
      dates.push(new Date(roofDate.getTime()));
      const dateName = roofDate.getDate();
      dateNames.push(dateName);

      roofDate.setDate(dateName + 1);
    }

    this.dates = dates;
    this.dateNames = dateNames;
  }
  
  fixHours(hours) {
    return (Number(hours)+24)%12 || 12;
  }
  fixMinutes(minutes) {
    return (Number(minutes)+60)%60 || 0;
  }
  submit() {
    this.selectedDate.setHours(this.displayAMPM === 'PM' ? this.displayHours + 12 : this.displayHours);
    this.selectedDate.setMinutes(this.displayMinutes);
    this._popover.dismiss(this.selectedDate);
  }

}
